import React from "react";
import dayjs from "dayjs";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useState, useMemo, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomHeader from "./Utility/CustomHeader";
import ActionCellInvoice from "./Utility/ActionCellInvoice";
import PulseLoader from "./Utility/PulseLoader";

ModuleRegistry.registerModules([AllCommunityModule]);


function ClinicBillingTable({ data = [], isLoading, isSuccess, isFetching }) {
  const gridRef = useRef(null);
  const [filter, setFilter] = useState("All Invoices");
 const location = useLocation();


  const tabButtonStyle = (key) =>
    `inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${filter === key
      ? "bg-white text-black shadow-sm"
      : "text-muted-foreground hover:text-black"
    }`;


  const [modalShow, setModalShow] = React.useState(false);
  const handleClose = () => setModalShow(false);
  const handleOpen = () => setModalShow(true);


  const [patientShow, setPatientShow] = useState(false);

  const handlePatientClose = () => setPatientShow(false);
  const handlePatientShow = () => setPatientShow(true);

  const tableStyle = `

  .btn-IdWmkZEQJd {
  border: none;
    background: #dcf2ff;
    color: #035ecf;
    width: 2.4rem;
    height: 2.4rem;
    display: flex
;
    align-items: center;
    justify-content: center;
    border-radius: .245rem;
    padding: .25rem .5rem;
  }


.ag-horizontal-right-spacer.ag-scroller-corner {
    display: none !important;
}

.ag-header-viewport {
  overflow-x: hidden !important;
  will-change: auto !important;
}

/* Soothing green strip for selected row */
.ag-theme-quartz .ag-row-selected::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #77c658; /* strip stays green */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 1;
}

.ag-cell-value{
  border-left: unset !important;
  border-right: 1px solid #e5e5e5 !important;
}


.ag-theme-quartz .ag-row-selected::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #77c658; /* strip stays green */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 1;
}

/* Override hover background for selected rows */
.ag-theme-quartz .ag-row-hover .ag-row-selected:hover {
  background-color: #f4fbf1 !important; /* same as selected */
}

.ag-checkbox-input-wrapper::before{
  display: none;
}

.ag-checkbox-input-wrapper::after{
  display: none;
}

  .ag-ltr .ag-sort-indicator-icon {
    padding-left: var(--ag-grid-size);
    display: none;
}

   .ag-header, .ag-advanced-filter-header {
    // background-color: #ff525a;
      background-color: #203342;
    border-bottom: var(--ag-borders-critical) var(--ag-border-color);
}

            .ag-full-width-container{
            height : 100% !important;
          }

        .ag-header-cell-text {
        font-size: 0.9rem;
      text-transform: uppercase;
      color: #1e374f;
      font-weight: 600;
      font-family: 'Nunito', sans-serif !important;

        }

              .ag-header-cell-resize::after{
                      background-color: #1991eb52;
                  }


            .ag-theme-quartz{
            padding: 0.4rem;
            }

              .ag-ltr .ag-cell{

                      text-align: center;
                      display: flex;
                      // justify-content: center;
                      align-items: center;
              }

              .ag-header{
                  // background-color: #edeff6;
                   border: none;
                  padding: 0.5rem 0;

                  min-height: 44px !important;
              }

              .ag-row {
               border: 1px solid #eeedf0;

              }

                  .ag-row-odd {
    background-color: #fff !important; /* Light gray */
  }

                    .ag-row-even {
    background-color: #f7f7f7 !important; /* Light gray */
  }






              .ag-root-wrapper{
                border: unset;
                background: transparent
              }

              .ag-body-viewport{
                border: 1px solid #8080801a;
                border-top-left-radius: 5px !important;
                border-top-right-radius: 5px !important;
                background-color: white;
              }

              .ag-theme-quartz .ag-header-cell-filter-button{
              display: none;}

.ag-header-cell-resize:after {
    background-color: #1991eb52;
    content: "";
    display: block;
    height: 30%;
    position: absolute;
    top: calc(50% - 30% * .5);2px;
    z-index: 1;
}

               .ag-cell, .ag-cell-not-inline-editing, .ag-cell-normal-height, .ag-cell-value, .ag-cell-focus{
                  font-size: .9rem;
               }

        .ag-body-vertical-scroll{
            display : none;
          }

    .ag-header-cell-sortable .ag-header-cell-label{
           justify-content: start;
        }
        
        .ag-ltr .ag-cell {
            font-weight: 500 !important;
            letter-spacing: 0.5px;
            color: #2b2b2b !important;
        }


          .odd-row {
          background-color: #f8f8fc;
        }
        
        .span-saceuu7u7{
            font-size: 13px; 
            background-color: #FAAB3C; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .span-jkmkmkmkm{
            font-size: 10px; 
            color: #6941C6 ;
            border: solid .1px #6941C6; 
            background-color: #F9F5FF; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            width: 7rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .span-jkmkmkmkmjbui{
            font-size: 10px; 
            color: #175CD3 ;
            border: solid .1px #B2DDFF; 
            background-color: #EFF8FF; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            width: 7rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
                .ag-header-cell-label{
        display: flex;
        justify-content: center;
        }
         .ag-cell:focus,
  .ag-cell-focus,
  .ag-row-focus {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

        
        
  
  `;
  const navigate = useNavigate();

  const getStableColor = (key) => {
    const bgColors = [
      "bg-danger bg-opacity-50",
      "bg-success bg-opacity-50",
      "bg-primary bg-opacity-50",
      "bg-warning bg-opacity-50",
      "bg-secondary bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-primary bg-opacity-50",
      "bg-info bg-opacity-50",
      "bg-warning bg-opacity-50",
      "bg-success bg-opacity-50",
      "bg-info bg-opacity-10",
      "bg-success bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-secondary bg-opacity-50",
    ];

    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = key.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % bgColors.length;
    return bgColors[index];
  };

  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    setRowData(data);
  }, [data]);

  const [colDefs, setColDef] = useState([
    {
      headerName: "PatientID",
      field: "invoiceNumber",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => (
        <span className="text-secondary fw-medium small">{params.value}</span>
      ),
    },

    {
      headerName: "Patient Name",
      field: "patientName",
      width: 170,
      minWidth: 170,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: function (params) {
        const name = params.value || "U";
        const initial = name.charAt(0).toUpperCase();
        const bgColor = getStableColor(name);

        return (
          <div className="d-flex align-items-center gap-2">
            <div
              className={`d-flex justify-content-center align-items-center rounded-circle text-white fw-bold ${bgColor}`}
              style={{ width: "2rem", height: "2rem", fontSize: "0.875rem" }}
            >
              {initial}
            </div>
            <span className="fw-bold text-secondary small">{name}</span>
          </div>
        );
      },
    },

    {
      headerName: "DateCheckIn",
      field: "invoiceDate",
      minWidth: 120,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: function (params) {

        const formattedDate = dayjs(params.value)
          .format("DD-MMM-YYYY")
          .replace(
            /-(\w{3})-/,
            (_, month) =>
              `-${month.charAt(0).toUpperCase()}${month
                .slice(1)
                .toLowerCase()}-`
          );
        return (
          <>
            <span className="text-secondary fw-medium small">
              {formattedDate}
            </span>
          </>
        );
      },
    },

    {
      headerName: "Diagnosis",
      field: "diagnosis",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => (
        <span className="text-secondary fw-medium small">{params.value}</span>
      ),
    },

    {
      headerName: "CheckInType",
      field: "appointmentType",
      minWidth: 110,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => (
        <span className="text-secondary fw-medium small">{params.value}</span>
      ),
    },

    {
      headerName: "Status",
      field: "status",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellStyle: {
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
      },
      cellRenderer: (params) => {
        let borderColor = "border border-secondary";
        let bgColor = "bg-light";
        let textColor = "text-secondary";
        // let dotColor = "bg-secondary";

        switch (params.value) {
          case "Paid":
            borderColor = "border border-success";
            bgColor = "bg-success";
            textColor = "text-white";
            // dotColor = "bg-success";
            break;
          case "Partially Paid":
            borderColor = "border border-warning";
            bgColor = "bg-warning";
            textColor = "text-white";
            // dotColor = "bg-warning";
            break;
          case "Unpaid":
            borderColor = "border border-danger";
            bgColor = "bg-danger";
            textColor = "text-white";
            // dotColor = "bg-danger";
            break;
        }

        return (
          <div
            className={`inline-block ${bgColor} ${textColor} ${borderColor} text-center px-3 py-1 rounded-full text-sm font-medium min-w-[120px]`}
            style={{ fontSize: "12px", lineHeight: "1rem" }}
          >
            {/* <span
              className={`rounded-circle ${dotColor}`}
              style={{ width: "8px", height: "8px" }}
            ></span> */}
            {params.value}
          </div>
        );
      },
    },

    {
      headerName: "Action",
      field: "Action",
      minWidth: 80,
      sortable: false,
      suppressSizeToFit: true,
      resizable: false,
      cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      cellRenderer: ActionCellInvoice


    },
  ]);

  const autoSizeStrategy = {
    type: "fitGridWidth",
    columnLimits: [
      {
        colId: "No of Team Members",
        minWidth: 900,
      },
    ],
  };

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      sortable: true,
      enableRowGroup: true,
      sort: "asc",
      resizable: true,
      headerComponent: CustomHeader,
    };
  }, []);

  // const rowSelection = {
  //   mode: "multiRow",
  //   headerCheckbox: false,
  // };

  const filteredInvoices = rowData.filter((inv) =>
    filter === "All Invoices" ? true : inv.status === filter
  );


  let content = null;


  if (isLoading || isFetching) {
    content = (
      <div className="flex justify-center items-center h-[30rem]">
        <PulseLoader />
      </div>
    );
  } else if (isSuccess && data.length === 0) {
    content = (
      <div className="flex flex-col justify-center items-center h-[30rem]">
        <img
          src="/Images/doctortable.png"
          alt="No Patients"
          className="w-[400px] mb-4"
        />
        <p className="text-muted text-sm">No Billing Data</p>
      </div>
    );
  } else {
    content = (
      <>

        {/* Table */}

        <div
          id="grid-wrapper"
          className="ag-theme-quartz custom-ag-grid"
          style={{
            width: "100%",
            height: "453px",
            backgroundColor: "#fff",
            minHeight: "32rem",
          }}
        >
          <style>{tableStyle}</style>
          <AgGridReact
            rowData={filteredInvoices}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            pagination={false}
            rowClass="tbl-row-sc"
            rowHeight={40}
            headerHeight={30}
            autoSizeStrategy={autoSizeStrategy}


            overlayNoRowsTemplate="<span class='text-secondary'>No Rows To Show</span>"
          />
        </div>
      </>

    );

  }

  return <div style={{ width: "100%",height:"89%" }}>
    {content}</div>;
}

export default ClinicBillingTable;
